import { BasicAddress } from '@/components/common/AddressDisplay/AddressDisplay';
import { PGTimeStampedRecord } from '@/lib/api/config';

/**
 * Record Types
 */
interface UserAssociatedRecord extends PGTimeStampedRecord {
  user_uuid: string;
}

export type TypeAccountType =
  | 'shopify'
  | 'stripe'
  | 'community'
  | 'cognito'
  | 'thinkific'
  | 'braintree';

export type TypeUserPreferenceName =
  | 'buyer_accepts_marketing'
  | 'app_notification'
  | 'marketing_sms'
  | 'buyer_accepts_developmental_content'
  | 'subscriber_shop_onboarding_complete'
  | 'transactional_sms';

export type TypeActivationType =
  | 'target_standalone'
  | 'amazon_standalone'
  | 'lovevery_standalone'
  | 'babylist_standalone'
  | 'pottery_barn_kids_standalone'
  | 'buy_buy_baby_standalone'
  | 'received_as_gift_standalone'
  | 'other_standalone'
  | 'no_retailer_selected_standalone';

export interface TypeAddressRecord extends UserAssociatedRecord, BasicAddress {
  county: string | null; // unused
  is_default: boolean; // unused
  is_billing: boolean; // unused
  phone_number: string | null;
  address_name: string | null; // unused
  user_uuid: string;
  latitude: string | null;
  longitude: string | null;
  valid_address: boolean | null;
  validated_at: string | null;
}

export interface TypeAccountRecord extends UserAssociatedRecord {
  account_type: TypeAccountType;
  account_id: string;
}

export interface TypeChildRecord extends PGTimeStampedRecord {
  name: string;
  birthday: string; // YYYY-MM-DD
  is_hidden: boolean;
  // a child could in theory belong to multiple users, but currently it will only
  // ever be associated with a single user
  users_uuid: string[];
}

export interface TypeRelationshipRecord extends UserAssociatedRecord {
  child: {
    uuid: string;
    name: string;
    birthday: string;
  };
  relationship_type: 'unknown'; // unused
}

export interface TypeUserPreferenceRecord extends UserAssociatedRecord {
  preference_name: TypeUserPreferenceName;
  preference_value: boolean;
}

export interface TypeActivationCodeRecord extends UserAssociatedRecord {
  activation_type: TypeActivationType;
  code: string;
}

export interface TypeUserRecord extends PGTimeStampedRecord {
  first_name: string;
  last_name: string;
  email: string;
  confirmed: boolean;
  phone_number?: string | null;
  source: string;
  language?: string;
  block_referrals?: boolean;
  addresses: TypeAddressRecord[];
  accounts: TypeAccountRecord[];
  relationships: TypeRelationshipRecord[];
  children: TypeChildRecord[];
  user_preferences: TypeUserPreferenceRecord[];
  activation_codes: TypeActivationCodeRecord[];
}

export interface TypeUserAuthRecord extends TypeUserRecord {
  name: string;
  family_name: string;
}

export interface TypeExperienceRecord {
  key: string;
}

export interface TypeExperiencesRecord {
  experience: TypeExperienceRecord;
}

export enum ProductAgeUnits {
  WEEK = 'weeks',
  MONTH = 'months',
  YEAR = 'years',
}
